import { render, staticRenderFns } from "./InactiveResult.vue?vue&type=template&id=4ceca0b8&scoped=true"
import script from "./InactiveResult.vue?vue&type=script&lang=ts"
export * from "./InactiveResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceca0b8",
  null
  
)

export default component.exports